import React from 'react';
import ReactDOM from 'react-dom/client';

function Hello({ name }) {
  return (
    <div className="p-4 rounded-xl border bg-gray-50">
      <h1 className="text-xl font-semibold">Hello, {name} 👋</h1>
      <p className="text-sm text-gray-600">Rails 8 + React + Tailwind</p>
    </div>
  );
}

// Auto-mount if the element exists
const el = document.getElementById('hello-root');
if (el) {
  const props = JSON.parse(el.dataset.props || '{}');
  ReactDOM.createRoot(el).render(<Hello {...props} />);
}

export default Hello;
